import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'

/** TRANSLATION*/
import { useTranslation } from 'react-i18next'

/** STYLE */

/** API */
import OperativeUnitApi from 'api/setting/treatments/operative-unit.api'

/** UTILS || SLICE */
import { submitModal } from 'app/slice/modal.slice'
import { isCreate, isDelete, isUpdate, isView } from 'utils/verification.utils'

/** COMPONENT */
import { faSearch, faTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import { Box, Grid, InputAdornment, Typography } from '@mui/material'
import HeaderCard from 'component/CardCustom/HeaderCard'
import TableCustom from 'component/Table/TableCustom'
import TableRowCommon from 'component/Table/TableRowCommon'
import { notiError, notiSuccess } from 'component/notifications/notifications'
import MainButton from 'new-components/buttons/main-button'
import SwitchButton from 'new-components/buttons/switch-button'
import SelectInput from 'new-components/inputs/select-input'
import TextInput from 'new-components/inputs/text-input'
import AlertModal from 'new-components/modal/alert-modal'
import PageModal from 'new-components/modal/page-modal'
import SnackbarComponent from 'new-components/snackbar/snackbar-component'

const permissions = {
  isCreate: isCreate(),
  isDelete: isDelete(),
  isUpdate: isUpdate(),
  isView: isView()
}
const initStateErrorMessage = {
  OPERATIVE_UNIT_NAME: ``,
  IS_DUPLICATE_OPERATIVE_UNIT_NAME: ``,
  OPERATIVE_UNIT_NAME_STRING_BASE: ``,
  OPERATIVE_UNIT_NAME_STRING_EMPTY: ``,
  OPERATIVE_UNIT_NAME_MAXIMUM_LENGTH: ``,
  OPERATIVE_UNIT_NAME_ANY_REQUIRED: ``,

  OPERATIVE_UNIT_NAME_EN: ``,
  IS_DUPLICATE_OPERATIVE_UNIT_NAME_EN: ``,
  OPERATIVE_UNIT_NAME_EN_STRING_BASE: ``,
  OPERATIVE_UNIT_NAME_EN_STRING_EMPTY: ``,
  OPERATIVE_UNIT_NAME_EN_MAXIMUM_LENGTH: ``,
  OPERATIVE_UNIT_NAME_EN_ANY_REQUIRED: ``
}
export default function OperativeUnits() {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const [operativeUnits, setOperativeUnits] = useState([])

  const [operativeUnitId, setOperativeUnitId] = useState(Number)
  const [operativeUnitName, setOperativeUnitName] = useState('')
  const [operativeUnitNameEn, setOperativeUnitNameEn] = useState('')
  const [operativeUnitStatus, setOperativeUnitStatus] = useState('')

  const [errorMessage, setErrorMessage] = useState(initStateErrorMessage)
  /** PAGINATION  */
  const [page, setPage] = useState(1)
  const [pageLimit, setPageLimit] = useState(10)
  const [rowCount, setRowCount] = useState(0)
  const [sortBy, setSortBy] = useState('createAt')
  const [sortType, setSortType] = useState('ASC')
  const [search, setSearch] = useState('')
  const [status, setStatus] = useState('ALL')

  const [isOpenAlertModal, setIsOpenAlertModal] = useState(false)
  const [statusAlertModal, setStatusAlertModal] = useState('')
  const [id, setId] = useState<number>(0)
  const [name, setName] = useState('')
  const [nameEn, setNameEn] = useState('')
  const [isOpenSnack, setIsOpenSnack] = useState(false)
  const [typeSnack, setTypeSnack] = useState<any>("success")
  const [labelSnack, setLabelSnack] = useState('')
  const [disabledSubmit, setDisabledSubmit] = useState(false)
  const [isOpen, setIsOpen] = useState(false)

  const loadData = async () => {
    try {
      const resp = await OperativeUnitApi.findAll({
        page: page,
        pageLimit: pageLimit,
        search: search,
        sortBy: sortBy,
        sortType: sortType,
        status: status === 'ALL' ? '' : status
      })
      if (resp.status === 200) {
        setRowCount(resp.headers['x-total'])
        setOperativeUnits(resp.data)
      } else {
        setOperativeUnits([])
      }
    } catch (error) {
      notiError('เกิดข้อผิดพลาด')
    }
  }

  useEffect(() => {
    loadData()
  }, [page, pageLimit, sortBy, sortType])

  const submit = () => {
    setDisabledSubmit(true)
    if (!operativeUnitName) {
      setDisabledSubmit(false)
      return setErrorMessage({ ...errorMessage, ...{ OPERATIVE_UNIT_NAME: t('OPERATIVE_UNIT.MESSAGE.OPERATIVE_UNIT_NAME') } })
    }

    dispatch(submitModal())
    OperativeUnitApi.create({ operativeUnitName, operativeUnitNameEn })
      .then((res: any) => {
        if (res.status !== undefined && res.status === 201) {
          notiSuccess(t('OPERATIVE_UNIT.MESSAGE.SUCCESS.CREATE'), '', null, null)
          resetForm()
          loadData()
          setIsOpen(false)
        } else {
          const err = res.response.data
          setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`OPERATIVE_UNIT.MESSAGE.${err.message}`) } })
        }
        setDisabledSubmit(false)
      })
      .catch((e) => {
        const err = e.response.data
        setDisabledSubmit(false)
        setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`OPERATIVE_UNIT.MESSAGE.${err.message}`) } })
      })
  }

  const submitEdit = () => {
    setDisabledSubmit(true)
    if (!operativeUnitName) {
      setDisabledSubmit(false)
      return setErrorMessage({ ...errorMessage, ...{ OPERATIVE_UNIT_NAME: t(`OPERATIVE_UNIT.MESSAGE.OPERATIVE_UNIT_NAME`) } })
    }
    dispatch(submitModal())
    OperativeUnitApi.update(operativeUnitId, {
      operativeUnitName,
      operativeUnitNameEn,
      status: operativeUnitStatus
    })
      .then((res: any) => {
        if (res.status !== undefined && res.status === 200) {
          notiSuccess(t(`OPERATIVE_UNIT.MESSAGE.SUCCESS.UPDATE`), '', null, null)
          resetForm()
          loadData()
          setIsOpen(false)
        } else {
          const err = res.response.data
          setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`OPERATIVE_UNIT.MESSAGE.${err.message}`) } })
        }
        setDisabledSubmit(false)
      })
      .catch((e) => {
        const err = e.response.data
        setDisabledSubmit(false)
        setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`OPERATIVE_UNIT.MESSAGE.${err.message}`) } })
      })
  }

  const clearErrorMessage = () => {
    setErrorMessage(initStateErrorMessage)
  }

  const resetForm = () => {
    setOperativeUnitId(0)
    setOperativeUnitName('')
    setOperativeUnitNameEn('')
    setOperativeUnitStatus('')
    clearErrorMessage()
    setIsOpen(false)
  }

  const onActive = () => {
    if (id) {
      OperativeUnitApi.updateStatus(id, statusAlertModal).then((resp) => {
        if (resp.status === 200) {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("success")
          setLabelSnack(t('OPERATIVE_UNIT.MESSAGE.SUCCESS.UPDATE_STATUS'))
          loadData()
        } else {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("error")
          setLabelSnack(t('OPERATIVE_UNIT.MESSAGE.ERROR'))
        }
      })
    }
  }
  const onDelete = async () => {
    if (id) {
      OperativeUnitApi.remove(id).then((resp) => {
        if (resp.status === 200) {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("success")
          setLabelSnack(t('OPERATIVE_UNIT.MESSAGE.SUCCESS.DELETE'))
          loadData()
        } else {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("error")
          setLabelSnack(t('OPERATIVE_UNIT.MESSAGE.ERROR'))
        }
      })
    }
  }

  const onEdit = (data: any) => {
    const { operativeUnitId: optUnitId, operativeUnitName: optUnitName, operativeUnitNameEn: optUnitNameEn, status: optUnitStatus } = data
    setOperativeUnitId(optUnitId)
    setOperativeUnitName(optUnitName)
    setOperativeUnitNameEn(optUnitNameEn)
    setOperativeUnitStatus(optUnitStatus)
    setIsOpen(true)
  }

  const onRequestSort = (sortByVal: string, sortTypeVal: string) => {
    setSortType(sortTypeVal)
    setSortBy(sortByVal)
  }

  const handleChangePage = (val: number) => {
    setPage(val)
  }

  const handleChangeRowsPerPage = (limit: number) => {
    setPageLimit(limit)
  }
  const handleChangeStatus = (statusVal: string) => {
    setStatus(statusVal)
  }
  const headCells = [
    { id: 'no', disablePadding: false, label: t('TABLE.NO') },
    { id: 'operativeUnitName', disablePadding: false, label: t('OPERATIVE_UNIT.TABLE.CELL.OPERATIVE_UNIT_NAME') },
    { id: 'operativeUnitNameEn', disablePadding: false, label: t('OPERATIVE_UNIT.TABLE.CELL.OPERATIVE_UNIT_NAME_EN') },
    { id: 'status', disablePadding: false, label: t('OPERATIVE_UNIT.TABLE.CELL.STATUS') },
    { id: 'updatedBy', disablePadding: false, label: t('OPERATIVE_UNIT.TABLE.CELL.UPDATED_BY') },
    { id: 'action', disablePadding: false, label: 'Action' }
  ]

  const renderData = (objData: any, no: number) => {
    no = page * pageLimit - pageLimit + no + 1
    const { operativeUnitId: optUnitId, operativeUnitName: optUnitName, operativeUnitNameEn: optUnitNameEn, updatedBy, updatedAt, status: optUnitStatus } = objData
    const statusBtnActive = optUnitStatus === 'ACTIVE' ? true : permissions.isUpdate.disabled
    const statusBtnInActive = optUnitStatus === 'INACTIVE' ? true : permissions.isUpdate.disabled
    const objRenderData = {
      key: optUnitId,
      id: optUnitId,
      obj: objData,
      columns: [
        { option: 'TEXT', align: 'center', label: no },
        { option: 'TEXT', align: 'left', label: optUnitName },
        { option: 'TEXT', align: 'left', label: optUnitNameEn },
        { option: 'STATUS', align: 'center', label: optUnitStatus },
        { option: 'UPDATE_BY', align: 'center', label: { updatedBy: updatedBy, updatedAt: updatedAt } },
        {
          option: 'ACTION',
          align: 'center',
          label: 'action',
          values: [
            { option: 'STATUS_ACTIVE', label: t(`STATUS.ACTIVE`), disabled: statusBtnActive },
            { option: 'STATUS_INACTIVE', label: t(`STATUS.INACTIVE`), disabled: statusBtnInActive },
            { option: 'DIVIDER', label: '', disabled: false },
            { option: 'EDIT', label: t(`BUTTON.EDIT`), disabled: permissions.isUpdate.disabled },
            { option: 'DELETE', label: t(`BUTTON.DELETE`), disabled: permissions.isDelete.disabled }
          ]
        }
      ]
    }
    return (
      <TableRowCommon
        {...objRenderData}
        onactive={() => handleSubmitModal(Number(objRenderData.id), 'ACTIVE', objRenderData.obj)}
        oninactive={() => handleSubmitModal(Number(objRenderData.id), 'INACTIVE', objRenderData.obj)}
        onedit={() => onEdit(objRenderData.obj)}
        ondelete={() => handleSubmitModal(Number(objRenderData.id), 'DELETE', objRenderData.obj)}
      />
    )
  }

  const handleSubmitModal = (id: number, status: string, obj?: any) => {
    setStatusAlertModal(status)
    setId(id)
    setIsOpenAlertModal(true)
    setName(obj.operativeUnitName)
    setNameEn(obj.operativeUnitNameEn)
  }

  return (
    <Box>
      <AlertModal
        isOpen={isOpenAlertModal}
        title={t(`OPERATIVE_UNIT.ALERT.${statusAlertModal === 'DELETE' ? 'TITLE_DELETE' : 'TITLE_ACTIVE'}`)}
        message={t(`OPERATIVE_UNIT.ALERT.${statusAlertModal === 'DELETE' ? 'CONFIRM_DELETE_' : 'CONFIRM_STATUS'}`, { operativeUnitName: name, operativeUnitNameEn: nameEn && `(${nameEn})`, status: t(`OPERATIVE_UNIT.ALERT.${statusAlertModal}`) })}
        type={statusAlertModal === 'DELETE' ? 'error' : 'warning'}
        handleClose={() => setIsOpenAlertModal(false)}
        onCancel={{ onClick: () => setIsOpenAlertModal(false), title: t('BUTTON.CANCEL') }}
        onSubmit={{ onClick: statusAlertModal === 'DELETE' ? onDelete : onActive, title: t('BUTTON.SUBMIT') }}
      />
      <SnackbarComponent
        onOpen={isOpenSnack}
        onClose={() => setIsOpenSnack(false)}
        label={labelSnack}
        type={typeSnack}
        transform={`translateX(calc(100vw - 100% - 32px)) translateY(calc(-100vh + 100% + ${window.innerHeight - 50}px))`}
        autoHideTime={3000}
      />
      <PageModal
        title={operativeUnitId ? t('OPERATIVE_UNIT.TITLE_UPDATE') : t('OPERATIVE_UNIT.TITLE_CREATE')}
        size='XS'
        isOpen={isOpen}
        handleClose={resetForm}
        onCancel={{ onClick: resetForm, title: t('OPERATIVE_UNIT.BUTTON.CANCEL') }}
        onSubmit={{ onClick: operativeUnitId ? submitEdit : submit, title: t('OPERATIVE_UNIT.BUTTON.SAVE'), disabled: disabledSubmit }}
      >
        <Box display="flex" flexDirection="column" gap="16px">
          {operativeUnitId ? <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography>{t('INPUT.LABEL_STATUS')}</Typography>
            <SwitchButton onChange={() => setOperativeUnitStatus(operativeUnitStatus === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE')} checked={operativeUnitStatus === 'ACTIVE' ? true : false} />
          </Box> : ''}
          <TextInput
            onChange={(event) => {
              setOperativeUnitName(event.target.value)
              clearErrorMessage()
            }}
            value={operativeUnitName}
            label={t('OPERATIVE_UNIT.INPUT.OPERATIVE_UNIT_NAME')}
            helperText={
              errorMessage.OPERATIVE_UNIT_NAME ||
              errorMessage.IS_DUPLICATE_OPERATIVE_UNIT_NAME ||
              errorMessage.OPERATIVE_UNIT_NAME_STRING_BASE ||
              errorMessage.OPERATIVE_UNIT_NAME_STRING_EMPTY ||
              errorMessage.OPERATIVE_UNIT_NAME_MAXIMUM_LENGTH ||
              errorMessage.OPERATIVE_UNIT_NAME_ANY_REQUIRED
            }
            required
          />
          <TextInput
            onChange={(event) => {
              setOperativeUnitNameEn(event.target.value)
              clearErrorMessage()
            }}
            value={operativeUnitNameEn}
            helperText={
              errorMessage.OPERATIVE_UNIT_NAME_EN ||
              errorMessage.IS_DUPLICATE_OPERATIVE_UNIT_NAME_EN ||
              errorMessage.OPERATIVE_UNIT_NAME_EN_STRING_BASE ||
              errorMessage.OPERATIVE_UNIT_NAME_EN_STRING_EMPTY ||
              errorMessage.OPERATIVE_UNIT_NAME_EN_MAXIMUM_LENGTH ||
              errorMessage.OPERATIVE_UNIT_NAME_EN_ANY_REQUIRED
            }
            label={t('OPERATIVE_UNIT.INPUT.OPERATIVE_UNIT_NAME_EN')}
          />
        </Box>
      </PageModal>
      <HeaderCard text={t('OPERATIVE_UNIT.TITLE')} />
      <Box paddingX="24px" paddingTop="16px">
        <Grid container spacing="16px">
          <Grid item xs={2}>
            <TextInput
              label={t('OPERATIVE_UNIT.SEARCH')}
              value={search}
              onChange={(event) => setSearch(event.target.value)}
              fullWidth
              inputProps={{
                endAdornment: (
                  <InputAdornment position="end" >
                    {!search ? <FontAwesomeIcon icon={faSearch} style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 15 }} /> :
                      <FontAwesomeIcon
                        icon={faTimes}
                        onClick={() => {
                          setSearch('');
                        }}
                        style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 17, cursor: 'pointer' }} />}
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={2}>
            <SelectInput
              onChange={(event) => {
                const value = event.target.value
                if (value) {
                  handleChangeStatus(value)
                }
              }}
              options={[
                { value: 'ALL', name: t('STATUS.ALL') },
                { value: 'ACTIVE', name: t('STATUS.ACTIVE') },
                { value: 'INACTIVE', name: t('STATUS.INACTIVE') }
              ]}
              label={t('STATUS.LABEL')}
              value={status}
              width="100%"
            />
          </Grid>
          <Grid item xs={1}>
            <MainButton
              title={t('INPUT.SEARCH')}
              type='primary'
              variant='contained'
              style={{ width: '120px' }}
              onClick={() => {
                setPage(1)
                loadData()
              }} />

          </Grid>
          <Grid item xs={7} textAlign="right">
            <MainButton title={t('OPERATIVE_UNIT.BUTTON.ADD')} disabled={permissions.isCreate.disabled} type='primary' variant='contained' onClick={() => setIsOpen(true)} startIcon={<AddCircleIcon />} />
          </Grid>
        </Grid>

        <Box paddingTop="24px">
          <TableCustom
            page={page}
            pageLimit={pageLimit}
            sortType={sortType}
            sortBy={sortBy}
            onSort={onRequestSort}
            setPageLimit={handleChangeRowsPerPage}
            setPage={handleChangePage}
            rowCount={rowCount}
            headCells={headCells}
            rowsData={operativeUnits.map((val, i) => {
              return renderData(val, i)
            })}
          />
        </Box>
      </Box>
    </Box>
  )
}
